import { ViewModel,View } from "binder"
import  { ReportSelectonPopupView } from "./reportSelectonPopup-view"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { stringIsNullOrEmpty } from "src/common/utilities";

export class ReportSelectonPopupViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.selector = new ReportFileSelector(this);    
        this.selector.onSelectionChanged = x=> this.selected =x; 
    }

    public set selector(v: ReportFileSelector) { this._selector = v; } public get selector(): ReportFileSelector { return this._selector;} private _selector: ReportFileSelector;
    public set selected(v: report) { this._selected = v; } public get selected(): report { return this._selected;} private _selected: report;

    closePopup(result: any) {
    }
    GetDefaultView(): View <ViewModel> {
        return new ReportSelectonPopupView();
    }
    
    public getTypeId(): string {
        return "VM-A65B32A6-736C-4B71-A075-977D24C5E5DE"
    }

    load(id:string){
        this.selector.selectById(id);
    }

    confirm(){
        if(this.selected){
            this.closePopup(this.selected.id);
        }else{
            this.closePopup(false);
        }
    }
    back(){
        this.closePopup(false);
    }
}

export class ReportFileSelector extends SelectorBaseViewModel<report>{
    constructor(parent:ViewModel) {
        super(parent);
    }
    protected async loadData(): Promise<report[]> {
        try {
            this.isLoading = true;
            let serviceResult = await ServerConnection.callServer('/Complex/ReportServices/GetAllReports',{
            });
            let result = serviceResult.Reports.map(x=>{
                let r = new report(this);
                r.id =x.Id;
                r.title =x.Name;
                return r;
            });
            return result;
        } catch (ex) {
            console.log(ex);
            return [];
        } finally {
            this.isLoading = false;
        }
    }
    
    
}
export class report extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
}